var load = function load(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return window.fetch(url, options).then(function (response) {
    return response.text();
  }).then(function (text) {
    var html = document.createElement('html');
    html.innerHTML = text;
    return html;
  });
};

export default load;